// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Fq","headline":"i_Fr","client":"i_Fs","icon":"i_Ft","logo":"i_Fu","options":"i_Fv"};